import { Typography, Divider, Grid } from "@material-ui/core";
import { PieceCard } from "../../components/PieceCard";
import { Spacer } from "../../components/Spacer";

export const Projects = () => {
    return (
        <div>
            <Typography align="center" variant='h4'>
                Projects
            </Typography>
            <Spacer size={20} />

            <Grid container spacing={10}>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: false,
                        title: "bluem",
                        subheader: "2020",
                        description: "ネコとロボットが雨の世界を旅するアドベンチャーゲーム\
                        \n雨の音と世界観にのめりこむ\
                        \n日本ゲーム大賞2020アマチュア部門優秀賞受賞",
                        videoId: "6znWWQNFE5Y",
                        steamLink: "https://store.steampowered.com/widget/1949670/",
                    }} />
                </Grid>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: true,
                        title: "コミックSE",
                        subheader: "2020",
                        description: "見ているコマのSEが鳴る電子漫画アプリ\
                        \nAIが視線を学習し場面に応じたSEを再生\
                        \nJPHACKS2020 Best Audience Award受賞",
                        videoId: "HroNiTiMmJw",
                        htmlLink: "https://github.com/jphacks/C_2008",
                    }} />
                </Grid>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: false,
                        title: "ぴょんぴょんボール",
                        subheader: "2019",
                        description: "タップしてジャンプ！\nひたすら上を目指せ！",
                        videoId: "Q_oN8wiPnpI",
                        iosLink: "https://apps.apple.com/jp/app/%E3%81%B4%E3%82%87%E3%82%93%E3%81%B4%E3%82%87%E3%82%93%E3%83%9C%E3%83%BC%E3%83%AB/id1467605944?itsct=apps_box_badge&amp;itscg=30200",
                    }} />
                </Grid>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: true,
                        title: "Play The Fox",
                        subheader: "2018-2021",
                        description:
                            "精霊を配置して技を発動するオンライン対戦ゲーム\
                        \n十二支をモチーフにしたドット絵がカワイイ"
                        ,
                        videoId: "z0xWLiln2N8",
                        iosLink: "https://apps.apple.com/us/app/play-the-fox/id1503850652?itsct=apps_box_link&itscg=30200",
                        steamLink: "https://store.steampowered.com/widget/1534430/"
                    }} />
                </Grid>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: false,
                        title: "pertica",
                        subheader: "2018",
                        description: "ものの位置を入れ替える事でゴールを目指すパズルゲーム\
                        \n単純だけど意外と難しい！",
                        videoId: "HhOONZaNotE",
                    }} />
                </Grid>
                <Grid item xs={12}>
                    <PieceCard props={{
                        reverse: true,
                        title: "kllaver",
                        subheader: "2017",
                        description: "左右に判定線を持つ音楽ゲーム\
                        \nピアノ曲とイラストが美しい",
                        videoId: "VmNxGXyjVOo",
                        iosLink: "https://apps.apple.com/us/app/kllaver/id1244738561?itsct=apps_box_link&itscg=30200",
                    }} />
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    And this website.
                    <br />
                    <small>© Narakuta 2024</small>
                </Grid>
            </Grid>
        </div>
    )
};
